import React from "react";
import Button from "@amzn/awsui-components-react/polaris/button";
import EllipsisText from "./EllipsisText";
import HoverTooltip from "./HoverTooltip";
import "./EllipsisText.css";

/** One download button, icon plus the truncated file name; greyed with a hover hint when there is no file. */
export default function FileDownloadButton({fileName, fallback = "File", hint = null, disabled = false, loading = false, loadingText, onClick}) {
    return (
        <span className="fileDownloadCell">
            <HoverTooltip text={disabled ? hint : null}>
                <Button className="fileDownloadButton" iconName="download" variant="inline-link"
                        disabled={disabled} loading={loading} loadingText={loadingText}
                        onClick={disabled || loading ? undefined : onClick}>
                    <EllipsisText text={fileName} fallback={fallback} />
                </Button>
            </HoverTooltip>
        </span>
    );
}
